/**
 * Check if an object has any own properties.
 * Empty objects ({}) are truthy in JavaScript — this catches them.
 * @param {any} obj - Value to check
 * @returns {boolean} true if obj is a non-null object with at least one key
 */
export const hasData = (obj) => obj && Object.keys(obj).length > 0;
